/**
 * Validate the core JobOrder fields, including contact email and number.
 * @param {object} jobOrder 
 * @returns {Array[]} Array of error messages. Empty if all good.
 */

import * as Yup from 'yup';

export const jobOrderSchema = Yup.object({
  client: Yup.object({
    address: Yup.object({
      id: Yup.string()
        .required('Please select a Job Site Address.'),
    }).required(),
    contact: Yup.object({
      id: Yup.string()
        .required('Please select a Contact Person.'),
      email: Yup.object({
        id: Yup.string()
          .required('Please select a Contact Email.'),
        email: Yup.string()
          .required('Please select a Contact Email.'),
      }).required(),
      number: Yup.object({
        id: Yup.string()
          .required('Please select a Contact Number.'),
        number: Yup.string()
          .required('Please select a Contact Number.'),
      }).required(),
    }).required(),
  }).required(),
  job_date: Yup.date()
    .typeError('Please select a valid Job Date.')
    .required('Please select a Job Date.'),
  start_time: Yup.string()
    .required('Please select a Start Time.'),
  end_time: Yup.string()
    .required('Please select an End Time.')
    .test(
      'max-12-hours',
      'End Time cannot be more than 12 hours after Start Time.',
      function (endTime) {
        const { start_time: startTime } = this.parent;

        // If either is missing, let the "required" rules handle it
        if (!startTime || !endTime) return true;

        // Expecting HH:mm format
        const [startH, startM] = String(startTime).split(':').map(Number);
        const [endH, endM]   = String(endTime).split(':').map(Number);

        if (
          Number.isNaN(startH) || Number.isNaN(startM) ||
          Number.isNaN(endH)   || Number.isNaN(endM)
        ) {
          // If format is weird, don't block the form here
          return true;
        }

        const startMinutes = startH * 60 + startM;
        const endMinutes   = endH * 60 + endM;

        // Handle cross-midnight: e.g., 23:00 → 03:00
        let diff = endMinutes - startMinutes;
        if (diff < 0) diff += 24 * 60;

        // Allow up to 12 hours (720 minutes)
        return diff <= 12 * 60;
      }
    ),
  endorser_name: Yup.string()
    .required('Please enter an Endorser Name.'),
  form_type: Yup.string()
    .oneOf(
      [
        'makati_gpc_form',
        'qc_form',
        'termite_control_form',
        'transmittal_form',
      ],
      'Please select a valid Form Type.'
    )
    .required('Please select a Form Type.'),
});

export async function validateJobOrder(jobOrder) {
  try {
    await jobOrderSchema.validate(jobOrder, { abortEarly: false });
    return [];
  } catch (err) {
    return err.inner.map(e => e.message);
  }
}
